<!--
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-06-07 10:25:55
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-04-07 10:52:31
-->
<template>
  <el-dialog
    :title="dialog.title"
    :visible.sync="dialog.show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    append-to-body
    width="50%"
    class="dialog"
  >
    <el-form
      ref="form"
      size="small"
      :model="column"
      :rules="rules"
      label-width="120px"
      label-suffix=":"
    >
      <el-form-item
        label="搜索类型"
        prop="type"
      >
        <el-radio-group
          v-model="column.type"
          size="small"
        >
          <el-radio
            v-for="(item, index) in options.typeList"
            :key="index"
            :label="item.value"
          >{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item
        label="搜索参数"
        prop="label"
      >
        <el-input
          v-model="column.label"
          placeholder="请输入"
          style="width: 188px"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item
        label="是否多选"
        v-if="column.type==='select'"
      >
        <el-switch
          v-model="column.multiple"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <template v-if="selectType.includes(column.type)">
        <el-form-item label="下拉字典">
          <el-radio-group
            v-model="column.dicFrom"
            size="mini"
          >
            <el-radio-button
              v-for="(item, index) in options.selectList"
              :key="index"
              :label="item.value"
            >{{ item.label }}</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <!-- 静态字典 -->
        <el-form-item
          label="静态字典"
          v-if="column.dicFrom === '静态'"
        >
          <dictory-select
            v-if="column.type === 'select'"
            :dicData="column.dicData"
            @change="updateDictory"
          />

          <dictory-cascader
            v-if="column.type === 'cascader'"
            :dicData="column.dicData"
            @change="updateDictory"
          />
        </el-form-item>

        <!-- 接口获取 -->
        <template v-if="column.dicFrom === '动态'">
          <el-form-item label="字典接口">
            <el-input
              v-model="column.dicUrl"
              clearable
              placeholder="请输入"
              style="width:500px"
            />
          </el-form-item>

          <el-form-item label="请求方式">
            <el-select
              style="width:188px"
              size="small"
              clearable
              placeholder="请选择"
              v-model="column.dicMethod"
            >
              <el-option
                v-for="(item,index) in options.methodList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
      </template>
    </el-form>

    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        size="small"
        @click="dialog.show = false"
      >取 消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="onSubmit"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { component, theme } from '@/dragComponents/model/default.js'

import dictorySelect from '@/dragComponents/config/dictory/select'
import dictoryCascader from '@/dragComponents/config/dictory/cascader'

export default {
  name: 'condition-dialog',
  components: {
    dictorySelect,
    dictoryCascader
  },
  props: {
    dialog: {
      type: Object,
      default: () => {
        return {}
      }
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    column: {
      type: [Object, Array]
    }
  },
  data() {
    return {
      theme: theme,
      selectType: ['select', 'cascader'],
      rules: {
        label: [{ required: true, message: '请输入', trigger: 'blur' }],
        type: [{ required: true, message: '请选择', trigger: 'blur' }]
      },
      options: {
        typeList: component.searchType,
        selectList: component.selectType,
        methodList: [
          {
            label: 'GET',
            value: 'GET'
          },
          {
            label: 'POST',
            value: 'POST'
          }
        ]
      }
    }
  },
  methods: {
    // 更新字典
    updateDictory(list) {
      this.column.dicData = list
    },
    onSubmit() {
      // 验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('change', this.column)
          this.dialog.show = false
        } else {
          return
        }
      })
    }
  }
}
</script>
